import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { useDispatch, useSelector } from "react-redux";
import useProjectCompanyIds from "./useProjectCompanyIds";
import {
    setCompanies, fetchCompanies
  } from "../../actions/companies";  

const useStyles = makeStyles((theme) => ({
  
}));

export default function CompanyDropDownBox({ projectId = 0 }) {
  const classes = useStyles();
  const companies = useSelector(state => state.companies.companies);
  const selectedCompany = companies && companies.find(company => company.selected);
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const projectCompanyIds = useProjectCompanyIds(projectId);

  const handleOpenCompanyMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseCompanyMenu = (id) => {
    setAnchorEl(null);
    const companiesTemp = companies.map(company => {
      if (company._id === id) {
        company.selected = true;
      } else {
        company.selected = false;
      }
      return company;
    });
    dispatch(setCompanies(companiesTemp));
  };

  useEffect(() => {
    companies.length === 0 && dispatch(fetchCompanies());
  }, [dispatch]);

  useEffect(() => {
    if (projectId > 0 && selectedCompany && projectCompanyIds.length > 0) {
      if (!projectCompanyIds.includes(selectedCompany._id)) {
        const companiesTemp = companies.map(company => ({
          ...company,
          selected: false,
        }));
        dispatch(setCompanies(companiesTemp));
      }
    }
  }, [projectId, projectCompanyIds]);

  const displayedCompanies = projectId > 0
    ? companies.filter(company => projectCompanyIds.includes(company._id))
    : companies;

  return (
    <>
    <Button color="primary" className={classes.buttonCategoryMenu} onClick={handleOpenCompanyMenu}
           endIcon={<ExpandMoreIcon/>}
          >{selectedCompany ? selectedCompany.name : 'All Store/Chain'}</Button>
    <Menu
        id="company-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseCompanyMenu}
      >
        <MenuItem onClick={handleCloseCompanyMenu}>All Store/Chain</MenuItem>
        {displayedCompanies && displayedCompanies.map((company) =>
          <MenuItem key={company._id} selected={company.selected} onClick={() => handleCloseCompanyMenu(company._id)}>{company.name}</MenuItem>
        )}
    </Menu>
    </>    
  );
}
